export const compose = (...fns: ((arg: any) => any)[]) => {
  return <T>(arg: T) => fns.reduceRight((acc, fn) => fn(acc), arg)
}
